import { sounds } from "../soundManager";
import { createDiv, delay } from "../util";

export enum Symbol {
    Blank,
    Star,
    X
}

export class Reel {
    div: HTMLElement;
    symbolDiv: HTMLElement;
    symbolOptions: Symbol[] = [];
    currentSymbol = Symbol.Blank;
    isSpinning = false;

    createElement(parent: HTMLElement) {
        this.div = createDiv(parent, "reel");
        this.symbolDiv = createDiv(this.div, "symbol");
        this.setSymbol(this.currentSymbol);
        return this.div;
    }

    addOption(symbol: Symbol) {
        this.symbolOptions.push(symbol);
    }

    setSymbol(symbol: Symbol) {
        this.currentSymbol = symbol;
        this.symbolDiv.className = "symbol";
        this.symbolDiv.classList.add("symbol-"+symbol);
    }

    async spin(spinTime: number, spinSpeed: number) {
        this.isSpinning = true;
        this.div.classList.add("spinning");
        sounds.play("click");

        // hide normal symbol and do spinning symbols instead
        this.div.innerHTML = "";
        await delay(spinSpeed * Math.random()); // random delay so they're not in sync
        this.showSpin(0, spinSpeed);

        await delay(spinTime);
        this.isSpinning = false; // stops spinning in < spinSpeed...
        this.div.classList.remove("spinning");
        this.div.innerHTML = "";

        // back to normal (cheating by choosing randomly)
        const symbol = this.symbolOptions[Math.floor(Math.random()*this.symbolOptions.length)];
        this.symbolDiv = createDiv(this.div, "symbol");
        this.setSymbol(symbol);

        sounds.play("clack");

        // final bounce
        this.symbolDiv.style.transform = "scale(1.2)";
        await delay(200);
        this.symbolDiv.style.transform = "scale(1)";

        // Stop spinning if no other reels are still spinning
        var reels = document.getElementsByClassName("reel spinning");
        if (!reels.length) {
            sounds.stop("click");
        }
    }

    async showSpin(spinIndex: number, spinSpeed: number) {
        if (this.isSpinning) {
            var thisSymbol = this.symbolOptions[spinIndex];
            
            // start thisSymbol at the top
            var div = createDiv(this.div, "symbol symbol-"+thisSymbol);
            div.style.transition = `transform ${spinSpeed}ms linear`;
            div.style.transform = "translate(0, -35px)";

            // move thisSymbol to the bottom
            await delay(50); // not sure why this needs to be this high but it does
            div.style.transform = "translate(0, 35px)";

            // halfway through that, start nextSymbol at the top
            await delay(spinSpeed / 2);
            var nextSpinIndex = (spinIndex + 1) % this.symbolOptions.length;
            this.showSpin(nextSpinIndex, spinSpeed);

            // then after spinSpeed has elapsed completely, clean up this symbol
            await delay(spinSpeed / 2 + 100);
            div.remove();
        }
    };

    reset() {
        this.symbolOptions = [];
        this.setSymbol(Symbol.Blank);
    }
}